import React, { useState, useEffect } from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  PDFViewer,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import { Button, Space, Typography, Divider, Spin } from "antd"; // Importar Spin
import { DownloadOutlined, ArrowLeftOutlined } from "@ant-design/icons";

import ExportPaso1 from "./exportPaso1";
import ExportPaso2 from "./exportPaso2";
import ExportPaso3 from "./exportPaso3";
import ExportPaso4 from "./exportPaso4";
import ExportPaso5 from "./exportPaso5";
import ExportPaso6 from "./ExportPaso6";
import ExportPaso7 from "./ExportPaso7";
import ExportPaso8 from "./ExportPaso8";
import config from "../../../../config";

const baseUrl = config.baseUrl;

const { Title } = Typography;
// Estilos para el PDF
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    paddingTop: 10,
    paddingRight: 60,
    paddingLeft: 60,
    paddingBottom: 100,
    fontFamily: "Times-Roman",
  },
  section: {
    padding: 10,
    flexGrow: 1,
  },
  title: {
    fontSize: 15,
    marginTop: 5,
    marginBottom: 20,
    textAlign: "center",
    fontWeight: "bold",
    fontFamily: "Times-Bold",
  },
  header: {
    marginBottom: 20,
  },
  logo: {
    justifyContent: "center",
    alignItems: "center",
  },
  title_1: {
    fontSize: 13,
    fontFamily: "Times-Bold",
    marginTop: 15,
    marginBottom: 20,
    textAlign: "center",
  },
  title_respuesta: {
    fontSize: 12,
    textAlign: "justify",
    marginBottom: 5,
    fontWeight: "normal", // Sin negrita
    borderBottomColor: "#000",
    textDecoration: "underline", // Subraya el texto
    fontWeight: "normal !important", // Asegura que no tenga negrita
  },
  date: {
    fontSize: 12,
    textAlign: "left",
    fontWeight: "bold",
  },

  checked: {
    width: 14,
    height: 14,
    borderWidth: 1,
    borderColor: "#000",
    marginRight: 6,
    marginTop: 2,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
  },
  textareaLabel: {
    fontSize: 12,
    textAlign: "justify",
    marginBottom: 8,
    lineHeight: 1.5,
    fontWeight: "bold", // Para resaltar el texto
    fontFamily: "Times-Bold",
    marginTop: 10,
  },

  textareaLabel_1: {
    fontSize: 12,
    textAlign: "justify",
    marginBottom: 8,
    lineHeight: 1.5,
  },

  textarea: {
    fontSize: 12,
    borderWidth: 1,
    borderColor: "#000",
    padding: 10,
    borderRadius: 5,
    width: "100%", // Ajuste automático al ancho disponible
    minHeight: 40, // Asegura que tenga un mínimo de altura
    flexShrink: 1, // Permite que el contenedor ajuste su tamaño según el contenido
    backgroundColor: "#f0f0f0",
    textAlign: "justify",
    marginBottom: 8,
    lineHeight: 1.5,
  },
  signatureContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    wrap: false, // Evita que se mueva a otra página
  },
  signature: {
    width: "40%",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  signatureImage: {
    width: 130,
    height: 70,
    marginBottom: 5,
  },
  signatureLine: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    width: "100%",
    marginBottom: 5,
  },
  signatureText: {
    fontSize: 10,
    textAlign: "center",
    fontFamily: "Times-Roman",
    width: "100%",
  },
  interlineText: {
    marginTop: 20,
    fontSize: 10,
    textAlign: "center",
    paddingLeft: 20,
    paddingRight: 20,
  },
  banner: {
    width: "100%",
    height: 40,
  },
  column: {
    width: "33%", // Cada columna ocupa un tercio del ancho
    alignItems: "center", // Centra los elementos dentro de las columnas
  },
  sectionTitle: {
    fontSize: 12,
    fontFamily: "Times-Bold",
    marginTop: 15,
    marginBottom: 10,
    textAlign: "center",
  },

  logoColumn: {
    width: "75%",
    alignItems: "center",
  },
  infoColumn: {
    width: "220px",
    borderWidth: 1,
    borderColor: "#000",
  },
  codeRow: {
    padding: 3,
    borderBottomWidth: 1,
    borderBottomColor: "#000",
  },
  dateVersionRow: {
    flexDirection: "row",
    height: "25px",
  },
  dateCell: {
    width: "55%",
    borderRightWidth: 1,
    borderRightColor: "#000",
    padding: 3,
    paddingLeft: 8,
    justifyContent: "center",
  },
  versionCell: {
    width: "45%",
    padding: 3,
    paddingLeft: 8,
    justifyContent: "center",
  },
  text: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    textAlign: "left",
  },
  codeText: {
    fontSize: 12,
    fontFamily: "Times-Roman",
    textAlign: "center",
  },

  audioText: {
    fontSize: 12,
    textAlign: "center",
    fontFamily: "Times-Roman",
    marginBottom: 5,
  },
  headerTable: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    paddingTop: 10,
    paddingRight: 10,
    paddingLeft: 10,
    marginBottom: 20,
  },
  tag: {
    backgroundColor: "rgb(25, 53, 111)", // Fondo azul oscuro para el primer Tag
    color: "#FFFFFF",
    fontSize: 12,
    textAlign: "center",
    padding: 5,
    marginBottom: 15,
    whiteSpace: "normal",
    wordWrap: "break-word",
  },
  greyTag: {
    backgroundColor: "grey",
    color: "#FFFFFF",
    fontSize: 12,
    textAlign: "center",
    padding: 5,
    marginBottom: 10,
  },
  noteTitle: {
    fontSize: 12,
    fontWeight: "bold",
    fontFamily: "Times-Bold",
    marginTop: 10,
  },
  noteText: {
    fontSize: 12,
    marginTop: 5,
    textAlign: "justify",
  },
      // ...tus estilos existentes
  footerCodeContainer: {
    position: "absolute",
    bottom: 20,
    right: 40,
  },
  footerCode: {
    fontSize: 10,
    fontStyle: "italic",
    color: "#0D0D0D",
    fontFamily: "Times-Bold", // <-- Esta línea hace el texto en negrita
  },

});

const MyDocument = ({ formData }) => {
  // Validar que formData exista para evitar errores
  if (!formData) return null;

  return (
    <Document>
      <Page size="legal" style={styles.page}>
        <View fixed>
          <View style={styles.headerTable} fixed>
            <View style={styles.logoColumn}>
              <Image style={styles.banner} src={"Banner_membrete.png"} />
            </View>

            <View style={styles.infoColumn}>
              <View style={styles.codeRow}>
                <Text style={styles.codeText}>
                  <Text style={{ fontWeight: "bold" }}>CÓDIGO: </Text>IR-F-113
                </Text>
              </View>
              <View style={styles.dateVersionRow}>
                <View style={styles.dateCell}>
                  <Text style={styles.text}>
                    <Text style={{ fontWeight: "bold" }}>FECHA: </Text>
                    2020-07-14
                  </Text>
                </View>
                <View style={styles.versionCell}>
                  <Text style={styles.text}>
                    <Text style={{ fontWeight: "bold" }}>VERSIÓN: </Text>V-1
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </View>
        <Text style={styles.title}>ANALISIS DE CAPACIDADES</Text>

        <ExportPaso1 formData={formData} styles={styles} />
        <ExportPaso2 formData={formData} styles={styles} />
        <ExportPaso3 formData={formData} styles={styles} />
        <ExportPaso4 formData={formData} styles={styles} />
        <ExportPaso5 formData={formData} styles={styles} />
        <ExportPaso6 formData={formData} styles={styles} />
        <ExportPaso7 formData={formData} styles={styles} />
        <ExportPaso8 formData={formData} styles={styles} />

        <View wrap={false}>

        <Text style={styles.title}>
          ¡Agradecemos su colaboración y respuestas!
        </Text>

        <View style={styles.signatureContainer}>
          <View style={styles.signature}>
            {formData.tipo_autorizacion === "Grabación de Audio" ? (
              <>
                <Text style={styles.audioText}>Firma disponible en audio</Text>
                <View style={styles.signatureLine} />
              </>
            ) : (
              <>
                {formData.firma_participante &&
                formData.firma_participante.trim() !== "" ? (
                  <Image
                    style={styles.signatureImage}
                    src={`${
                    baseUrl + formData.firma_participante
                  }?t=${Date.now()}`}
                  />
                ) : (
                  <View
                    style={[
                      styles.signatureImage,
                      {
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    ]}
                  >
                    <Text style={{ color: "#888", fontSize: 10 }}>
                      Firma no disponible
                    </Text>
                  </View>
                )}
                <View style={styles.signatureLine} />
              </>
            )}
            <Text style={styles.signatureText}>
              Participante legal{" "}
              {formData?.tipo_autorizacion === "Firma por Testigo" &&
                "(Firma por testigo)"}
            </Text>
          </View>

          <View style={styles.signature}>
            {formData.firma_tecnico && formData.firma_tecnico.trim() !== "" ? (
              <Image
                style={styles.signatureImage}
                src={`${
                    baseUrl + formData.firma_tecnico
                  }?t=${Date.now()}`}
              />
            ) : (
              <View
                style={[
                  styles.signatureImage,
                  {
                    justifyContent: "center",
                    alignItems: "center",
                  },
                ]}
              >
                <Text style={{ color: "#888", fontSize: 10 }}>
                  Firma no disponible
                </Text>
              </View>
            )}

            <View style={styles.signatureLine} />
            <Text style={styles.signatureText}>
              Profesional acompañante / Asistencia técnica
            </Text>
          </View>
        </View>

        <Text style={styles.interlineText}>
          Certifico bajo la gravedad de juramento que toda la información
          contenida en el presente documento, es correcta y verdadera, me
          comprometo a suministrar cualquier otra información que pueda ser
          requerida.
        </Text>
        </View>

        <View style={styles.footerCodeContainer}>
          <Text style={styles.footerCode}>
            Código Único: {formData?.codigo_pdf || "N/A"}
          </Text>{" "}
        </View>
      </Page>
    </Document>
  );
};

const ExportAnalisisCapacidadesPDF = ({ formData, actionVolver }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [formDataInitial, setFormDataInitial] = useState(null);
  const [error, setError] = useState(null);
  const [pdfReady, setPdfReady] = useState(false);
  const fileName = `3_Capacidades_${formData.fecha_archivo}.pdf`;

  const handlePDFLoad = () => {
    setIsLoading(false);
    setPdfReady(true);
  };

  useEffect(() => {
    const inicializarFormulario = async () => {
      if (!formData) {
        setError("No hay datos disponibles para generar el PDF");
        setIsLoading(false);
        return;
      } else {
        setFormDataInitial(formData);
        setIsLoading(false);
      }
    };

    inicializarFormulario();
  }, [formData]);

  const renderPDFContent = (fileName) => {
    if (!formDataInitial) return null;

    return (
      <>
        <Space className="mb-8">
          <PDFDownloadLink
            document={<MyDocument formData={formDataInitial} />}
            fileName={fileName}
          >
            {({ loading, error }) => (
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                loading={loading}
                disabled={!!error}
                size="large"
              >
                Descargar PDF
              </Button>
            )}
          </PDFDownloadLink>
        </Space>

        <div
          className="w-full border border-gray-300 rounded-lg"
          style={{ height: "800px" }}
        >
          <PDFViewer
            style={{ width: "100%", height: "100%" }}
            onLoad={handlePDFLoad}
          >
            <MyDocument formData={formDataInitial} />
          </PDFViewer>
        </div>
      </>
    );
  };

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <Title level={2} style={{ color: "#1890ff", fontWeight: "bold" }}>
              Reporte de análisis de capacidades
            </Title>
            <Divider />
          </div>

          <Button
            type="danger"
            size="large"
            icon={<ArrowLeftOutlined />}
            onClick={actionVolver}
            style={{ marginBottom: "20px" }}
          >
            Volver
          </Button>

          {error && (
            <div className="text-red-500 text-center mb-4">{error}</div>
          )}

          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "800px",
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            renderPDFContent(fileName)
          )}
        </div>
      </div>
    </div>
  );
};

export default ExportAnalisisCapacidadesPDF;
